import { motion } from "framer-motion";
import { ArrowRight, Printer, PenTool, Box } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import FeatureSet from "@/components/FeatureSet";

const services = [
  {
    icon: Printer,
    title: "3D-Druck",
    description: "FDM-Druck in guter Qualität. Prototypen, Ersatzteile, Designobjekte. PLA, PETG, ABS, Flex und mehr.",
    href: "/3d-druck",
    cta: "Mehr erfahren",
  },
  {
    icon: Box,
    title: "CAD-Konstruktion",
    description: "3D-Modelle aus Skizzen, Bemaßungen oder vorhandenen Teilen, druckfertig oder zum Weiterverwenden.",
    href: "/cad",
    cta: "Mehr erfahren",
  },
  {
    icon: PenTool,
    title: "Technisches Zeichnen",
    description: "Technische Zeichnungen nach Vorgabe, für Werkstätten, Hersteller oder zur Dokumentation.",
    href: "/cad",
    cta: "Mehr erfahren",
  },
];

const Index = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <Navbar />

      {/* Hero */}
      <header className="relative bg-[#1d1d1f] overflow-hidden" aria-label="Hero">
        {/* Background GIF */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "url(/IMG_90381-ezgif.com-cut.gif)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(8px) brightness(0.35)",
          }}
          aria-hidden="true"
        />

        {/* Content – proper padding to avoid navbar overlap */}
        <div className="relative z-10 max-w-6xl mx-auto px-6 pt-36 pb-28 md:pt-44 md:pb-36">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[13px] font-medium text-white/40 uppercase tracking-widest mb-5">
              Potsdam
            </p>
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-[1.05] tracking-tight mb-6 max-w-3xl">
              Von der Skizze<br />zum fertigen Teil.
            </h1>
            <p className="text-[17px] md:text-[19px] text-white/55 max-w-lg leading-relaxed mb-10">
              3D-Druck, CAD-Konstruktion und technische Zeichnungen,
              unkompliziert und direkt.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="mailto:konstantin.florian.kalla@3d-druck-potsdam.de"
                className="inline-flex items-center justify-center gap-2 bg-white text-[#1d1d1f] text-[15px] font-semibold px-6 py-3.5 rounded-full hover:bg-white/90 transition-colors"
              >
                Anfrage stellen
                <ArrowRight className="w-4 h-4" />
              </a>
              <Link
                to="/3d-druck"
                className="inline-flex items-center justify-center gap-2 border border-white/20 text-white/75 text-[15px] font-medium px-6 py-3.5 rounded-full hover:border-white/40 hover:text-white transition-colors"
              >
                3D-Druck Details
              </Link>
            </div>
          </motion.div>
        </div>
      </header>

      {/* Services – 3 cards */}
      <section id="leistungen" className="bg-white py-24">
        <div className="max-w-6xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <p className="text-[13px] font-medium text-[#6e6e73] uppercase tracking-widest mb-3">
              Leistungen
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1d1d1f]">
              Drei Dinge aus einer Hand.
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-px bg-[#e5e5ea]">
            {services.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-white p-8 group hover:bg-[#f5f5f7] transition-colors duration-300 flex flex-col"
              >
                <div className="w-10 h-10 rounded-full bg-[#1d1d1f]/5 flex items-center justify-center mb-6 group-hover:bg-[#1d1d1f] transition-colors duration-300">
                  <s.icon className="w-4 h-4 text-[#1d1d1f] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-[20px] font-semibold text-[#1d1d1f] mb-3">{s.title}</h3>
                <p className="text-[14px] text-[#6e6e73] leading-relaxed flex-1 mb-6">{s.description}</p>
                <Link
                  to={s.href}
                  className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#1d1d1f] hover:gap-3 transition-all"
                >
                  {s.cta} <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 3D-Druck Detail – dark */}
      <FeatureSet />

      {/* Contact */}
      <section id="kontakt">
        <ContactSection />
      </section>

      <Footer />
    </div>
  );
};

export default Index;
